import React, { useState, useEffect } from 'react'
import { Text, View, StyleSheet, Font, Image } from '@react-pdf/renderer'
import ScaleBar from './ScaleBar'
import TableGrid from './TableGrid'
import Pointers from './Pointers'

Font.registerHyphenationCallback(word => [word]);

const styles = StyleSheet.create({
    categoryText: {
        paddingLeft: '0%',
        paddingRight: '5%',
        marginTop: 45,
    },
    tableHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        paddingLeft: '5%',
        paddingRight: '5%',
        backgroundColor: 'rgb(226 232 240)',
    },
    tableHeaderTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: 5,
        paddingBottom: 5,
    },
    tableHeaderTitleText1: {
        fontFamily: 'Inter',
        fontSize: 15,
        fontWeight: 500,
        marginRight: 5,
    },
    tableHeaderTitleText2: {
        fontFamily: 'Inter',
        fontSize: 12,
    },
    tableContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        borderBottom: '1 solid rgb(226 232 240)',
    },
    tableFirstCol: {
        width: '60%',
        backgroundColor: '#ffffff',
    },
    tableFirstColAnswer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
    },
    tableFirstColAnswerNumber: {
        width: '10%',
        paddingLeft: 3,
        paddingRight: 3,
        marginTop: -1,
        paddingTop: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    tableFirstColAnswerText: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '80%',
        paddingRight: 10,
        paddingTop: 0,
        paddingBottom: 3,
    },
    tableFirstColAnswerPoints: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '10%',
        height: '100%',
        textAlign: 'right',
        paddingLeft: 5,
        paddingRight: 5,
    },
    tableLastCol: {
        width: '40%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'rgb(226 232 240)',
        borderBottom: '1 solid #fff',
        paddingRight: 7,
        opacity: 0.7,
    },
    tableLastColRows: {
        width: '100%',
        flexDirection: 'row',
        height: 15,
    },
    scaleBarContainer: {
        position: 'relative',
        zIndex: 50,
        display: 'flex',
        flexDirection: 'row',
    },
    gridContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: '5.5%',
        top: -1,
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1 solid rgb(226 232 240)',
    },
    inclImage: {
        width: '103px',
        height: '119px',
    },
    inclImageText: {
        display: 'block',
        fontFamily: 'Inter',
        fontSize: 9,
        fontWeight: 500,
        lineHeight: 1.4,
        textAlign: 'right',
    },
    inclImageText2: {
        display: 'block',
        fontFamily: 'Inter',
        fontSize: 10,
        fontWeight: 600,
        lineHeight: 1.4,
        textAlign: 'center',
        paddingTop: 10,
    }
});

const AnswersTableGuide = ({ answersData, categoriesData, matchCategory, spaceTop, spaceBottom, uiData }) => {

    const current = uiData.current;
    const currentText = `(${current})`;

    const [matchedCategory, setMatchedCategory] = useState(null);
    const [answersFromCategory, setAnswersFromCategory] = useState([]);

    useEffect(() => {
        if (answersData && categoriesData) {
            const categoryData = categoriesData.find(item => item.name === matchCategory);
            setMatchedCategory(categoryData);

            if (matchCategory === uiData.lowest) {
                const allAnswers = [...answersData];
                const lowestPoints = allAnswers.sort((a, b) => a.points - b.points);
                const result = lowestPoints.slice(0, 10);
                setAnswersFromCategory(result);
            } else if (matchCategory === uiData.highest) {
                const allAnswers = [...answersData];
                const highestPoints = allAnswers.sort((a, b) => b.points - a.points);
                const result = highestPoints.slice(0, 10);
                setAnswersFromCategory(result);
            } else {
                const result = answersData.filter(item => item.category === matchCategory);
                setAnswersFromCategory(result);
            }
        }
    }, [answersData, categoriesData, matchCategory, uiData.lowest, uiData.highest]);


    return (
        <>

            <View style={styles.tableHeader}>
                <View style={styles.tableHeaderTitle}>
                    <Text style={styles.tableHeaderTitleText1}>{matchCategory}</Text>
                    <Text style={styles.tableHeaderTitleText2}>{currentText}</Text>
                </View>
                {matchedCategory && (
                    <View
                        style={{
                            color: '#ffffff',
                            fontFamily: 'Inter',
                            fontSize: 18,
                            fontWeight: 700,
                            padding: 5,
                            backgroundColor: matchedCategory.points <= 35 ? "#dc2626" : (matchedCategory.points <= 50 ? "#eac714" : (matchedCategory.points <= 65 ? "#7bb662" : "#639754")),
                        }}
                    >
                        <Text>{matchedCategory.points}</Text>
                    </View>
                )}
            </View>
            <View style={{
                display: 'flex',
                flexDirection: 'column',
            }}>
                <View
                    style={{
                        position: 'relative',
                        paddingLeft: '5%',
                        paddingRight: '5%',
                        marginTop: spaceTop,
                        marginBottom: spaceBottom,
                        width: '100%',
                    }}
                >
                    <View style={styles.gridContainer} zIndex={9999}>
                        <View style={{ width: '60%' }}></View>
                        <View style={{ width: '40%' }}>
                            <Pointers uiData={uiData} />
                            <TableGrid />
                        </View>
                    </View>

                    {answersFromCategory.map(
                        ({ id, answer, points }, index) => {

                            const getBorderRadius = (points) => {
                                return points > 105 ? { borderTopRightRadius: 0, borderBottomRightRadius: 0, marginRight: -7 } : { borderTopRightRadius: 5, borderBottomRightRadius: 5 };
                            };

                            return (
                                <View key={id}>
                                    <View style={styles.tableContainer}>
                                        <View style={styles.tableFirstCol}>
                                            <View style={styles.tableFirstColAnswer}>
                                                <View style={styles.tableFirstColAnswerNumber}>
                                                    <Text
                                                        style={{
                                                            fontFamily: 'Inter',
                                                            fontSize: 10,
                                                            fontWeight: 600,
                                                            lineHeight: 1.1,
                                                        }}
                                                    >
                                                        F{(id >= 10 ? id + '.' : '0' + id + '.')}
                                                    </Text>
                                                </View>
                                                <View style={[styles.tableFirstColAnswerText, { height: 25, paddingBottom: 0 }]}>
                                                    <Text
                                                        style={{
                                                            fontFamily: 'Inter',
                                                            fontSize: 8,
                                                            lineHeight: 1.2,
                                                        }}
                                                    >
                                                        {(() => {
                                                            const fullText = answer;
                                                            const maxLength = 120;
                                                            return fullText.length > maxLength ? fullText.substring(0, maxLength) + '...' : fullText;
                                                        })()}
                                                    </Text>
                                                </View>
                                                <View style={styles.tableFirstColAnswerPoints}>
                                                    <Text
                                                        style={{
                                                            fontFamily: 'Inter',
                                                            fontSize: 10,
                                                            fontWeight: 700,
                                                        }}
                                                    >
                                                        {points}
                                                    </Text>
                                                </View>
                                            </View>
                                        </View>
                                        <View style={styles.tableLastCol}>
                                            <View style={styles.tableLastColRows}>
                                                <View
                                                    style={{
                                                        height: 15,
                                                        width: points + '%',
                                                        backgroundColor: points <= 35 ? "#dc2626" : (points <= 50 ? "#eac714" : (points <= 65 ? "#7bb662" : "#639754")),
                                                        ...getBorderRadius(points)
                                                    }}
                                                >
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            );
                        }
                    )}
                    <View style={styles.scaleBarContainer}>
                        <View style={{ width: '60%' }}></View>
                        <View style={{ width: '40%', marginBottom: 10 }}>
                            <ScaleBar />
                        </View>
                    </View>
                </View>

                {matchedCategory && (
                    <View style={styles.categoryText}>
                        {matchedCategory.description.map((item, index) => {
                            switch (item.type) {
                                case 'paragraph':
                                    return <Text
                                        key={index}
                                        style={{
                                            display: 'block',
                                            fontFamily: 'Inter',
                                            fontSize: 9,
                                            lineHeight: 1.4,
                                            marginBottom: 10,
                                        }}>{item.text}</Text>;
                                default:
                                    return null;
                            }
                        })}
                    </View>
                )}  

            </View>
        </>
    )
}

export default AnswersTableGuide